import React from 'react'
import Todo from './Components/Todo';

function App() {
    return (
        <div style={{background:"beige" }}>
            <Todo/>
        </div>
    )
}

export default App;
